import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { EventBusService } from 'app/modules/shared/services/event-bus.service';
import { UpdateExpandedStatus } from 'ng2-app/borrower-sidebar/borrower-sidebar.actions';

@Component({
  selector: 'app-collapsible-container',
  templateUrl: './collapsible-container.component.html',
  styleUrls: ['./collapsible-container.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({ height: '*', overflow: 'hidden' })),
      state('closed', style({ height: 0, overflow: 'hidden' })),
      transition('open <=> closed', [
        animate(250)
      ])
    ]),
    trigger('expandInOut', [
        transition('* => void', [
            style({ height: '*', overflow: 'hidden' }),
            animate(300, style({ height: 0 }))
        ]),
        transition('void => *', [
            style({ height: '0', overflow: 'hidden' }),
            animate(300, style({ height: '*' }))
        ])
    ])
  ]
})
export class CollapsibleContainerComponent implements OnInit {
  @Input() expanded: boolean;
  @Input() name: string;
  @Input() disableToggle: boolean = false;

  constructor(
    private eventBusService: EventBusService,
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.eventBusService.subscribe(this.eventBusService.types.OpenCollapsibleContainerEvent).subscribe((event) => {
      if(event.name === this.name){
        this.openContainer();
      }
    });
    this.eventBusService.subscribe(this.eventBusService.types.CloseCollapsibleContainerEvent).subscribe((event) => {
      if(event.name === this.name){
        this.closeContainer();
      }
    });
  }

  toggleExpanded() {
    if(!this.disableToggle){
      this.expanded = !this.expanded;
      this.dispatchExpandEvent();
    }
  }

  openContainer(){
    this.expanded = true;
    this.dispatchExpandEvent();
  }

  closeContainer(){
    this.expanded = false;
    this.dispatchExpandEvent();
  }

  dispatchExpandEvent() {
    this.store.dispatch(new UpdateExpandedStatus(this.name, this.expanded));
  }
}
